<script setup lang="ts">
import { ref, onMounted } from "vue";
import { trans, isLoaded } from "laravel-vue-i18n";
import { useAuthStore } from "@/ts/stores/auth";

const authStore = useAuthStore();
const component = ref<HTMLDivElement>();

const emit = defineEmits(["cancel", "renew", "mounted"]);

onMounted(() => {
    emit("mounted", component.value!.offsetHeight);

    let translationsChecker = setInterval(() => {
        if (isLoaded()) {
            emitComponentHeight();
            clearInterval(translationsChecker);
        }
    }, 50);

    window.addEventListener("resize", () => {
        emitComponentHeight();
    });

    window.addEventListener("orientationchange", () => {
        emitComponentHeight();
    });
});

function emitComponentHeight() {
    if (component.value) {
        emit("mounted", component.value!.offsetHeight);
    }
}
</script>

<template>
    <div ref="component" class="absolute top-0 left-0 w-full px-4 pt-10 pb-4 md:p-10 lg:px-20 lg:py-[3.75rem]">
        <h3 class="mb-4 text-center font-heading text-32 font-[690] uppercase [font-stretch:_190%] md:text-60">Hey {{ authStore.user.first_name }}.</h3>
        <p class="mb-10 text-center font-medium leading-normal" v-html="trans('membership.renewal_description')"></p>
        <p class="mb-10 text-center font-medium leading-normal text-gray-800" v-html="`${trans('membership.membership_valid_until')} ${authStore.user.membership_end_date}`"></p>
        <div class="flex flex-col items-center gap-4">
            <button @click="emit('renew')" class="btn btn-green" v-html="trans('membership.renew')"></button>
            <button @click="emit('cancel')" href="#" class="btn-gray-300 btn" v-html="trans('membership.cancel')"></button>
        </div>
    </div>
</template>
